import { Platform } from 'react-native';
export const createAndroidMenu = () => {
  throw new Error('Tried to create android menu on ' + Platform.OS);
};
//# sourceMappingURL=index.js.map